// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__l5LZE","empty":"ModalGraph_empty__16MBF"};